import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import MultiSelectUserRole from "../../../components/common/UserSelect/MultiSelectUserRole";
import {assignRole} from "../../../redux/actions/roles.actions";
import {fetchDealershipUsers} from "../../../redux/actions/dealership.actions";
import {useSearchParams} from "react-router-dom";
import ModalShell, { ModalLoading } from "../../../components/common/Modals/ModalShell";

const RemoveStaffModal: React.FC<ModalProps> = ({open, setOpen, object_id}) => {
    const dealer_id = object_id;
    const dispatch = useDispatch<AppDispatch>();
    const [searchParams, setSearchParams] = useSearchParams();
    const [selected, setSelected] = useState<any[]>([]);
    const [isConfirmed, setIsConfirmed] = useState(false);

    const {loading} = useSelector((state: RootState) => state.users);
    const {error:roleError} = useSelector((state: RootState) => state.roleUsers);

    const handleConfirm = async () => {
        setIsConfirmed(true);
        await dispatch(assignRole({role_id: 'customer', users: selected}));
    }

    const  handleReset = () => {
        setSelected([]);
        setIsConfirmed(false);
    }

    const handleClose = ()=> {
        handleReset();
        setOpen(false);

        if (!roleError && !loading && isConfirmed){
            if (dealer_id) {
                dispatch(fetchDealershipUsers({id:dealer_id, params:searchParams.toString()}));
            }
        }
    }

    const succeeded = !loading && !roleError && isConfirmed;
    const userCount = `${selected.length} ${selected.length===1 ? `user` : `users`}`;

    return (
      <ModalShell
        open={open}
        onClose={handleClose}
        size={loading || roleError || succeeded ? "sm" : "md"}
        tone={loading ? undefined : roleError ? "error" : succeeded ? "success" : undefined}
        title={loading ? "Loading…" : roleError ? "An error occurred" : succeeded ? "Staff removed" : "Remove users from staff"}
        subtitle={!loading && !roleError && !succeeded ? "This action will change the selected users' role to customer." : undefined}
        actions={loading || roleError ?
          <button className="btn" onClick={handleClose}>Close</button>
          : succeeded ?
          <>
            <button className="btn dlg-actions-start" onClick={handleReset}>Remove more staff</button>
            <button className="btn btn-primary" onClick={handleClose}>Done</button>
          </>
          :
          <>
            <button className="btn" onClick={handleClose}>Cancel</button>
            <button className="btn btn-danger" disabled={selected.length===0} onClick={handleConfirm}>Remove</button>
          </>
        }
      >
        {loading ?
          <ModalLoading/>
          : roleError ?
          <p>{roleError}</p>
          : succeeded ?
          <p>{`${userCount} successfully assigned to the customer role.`}</p>
          :
          <div className="dlg-section">
            <span className="dlg-label">{`Remove ${userCount} from staff`}</span>
            <MultiSelectUserRole checked={selected} setChecked={setSelected} dealership_id={dealer_id} role={'customer'}/>
          </div>
        }
      </ModalShell>
  )
};

export default RemoveStaffModal;